import React from 'react';
import { connect } from 'react-redux';
import { mediaPickerActions } from '../../../store';
import MediaPickerLoadMoreCard from '../../../common/MediaPickerLoadMoreCard';
import MediaPickersConstants from '../../../MediaPickersConstants';

const LogoStockImagesLoadMoreCard = (props) => {
    const { 
        setProperty, logoStockImagesOrientation, searchLogoStockImages, logoStockImagesSearchValue, logoStockImagesDefaultKeyword, logoStockImagesLoading, 
        galleryCardWidth, galleryCardHeight, logoStockImagesPageNumber
    } = props;
    
    const onLoadMoreButtonClick = () => {
        setProperty('logoStockImagesLoading', true)
        const keyword = logoStockImagesSearchValue || logoStockImagesDefaultKeyword;
        searchLogoStockImages(keyword, logoStockImagesOrientation, logoStockImagesPageNumber + 1, MediaPickersConstants.LOGO_STOCK_IMAGES_PER_PAGE, () => {
            setProperty('logoStockImagesLoading', false)
        });
    }

    return (
        <MediaPickerLoadMoreCard
            key={'load-more-button'}
            onLoadMoreButtonClick={onLoadMoreButtonClick}
            isLoading={logoStockImagesLoading}
            galleryCardWidth={galleryCardWidth}
            galleryCardHeight={galleryCardHeight}
        />
    );
};

const mapStateToProps = (state) => {
    const { 
        logoStockImagesSearchValue, 
        logoStockImagesDefaultKeyword,
        logoStockImagesLoading,
        logoStockImagesPageNumber,
        logoStockImagesOrientation
    } = state.mediaPicker;

    return {
        logoStockImagesOrientation, 
        logoStockImagesSearchValue,
        logoStockImagesDefaultKeyword,
        logoStockImagesLoading,
        logoStockImagesPageNumber
    };
}

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(mediaPickerActions.setProperty(key, value));
    const searchLogoStockImages = (keywords, orientation, pageNumber, itemsPerPage, callback) => dispatch(mediaPickerActions.searchLogoStockImages(keywords, orientation, pageNumber, itemsPerPage, callback));

    return { 
        setProperty,
        searchLogoStockImages 
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LogoStockImagesLoadMoreCard);